import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {connect} from 'react-redux';
import classnames from 'classnames';
import Modal from 'components/Modal';
import Tooltip from 'components/Tooltip';
import {TOOLTIP_POSITION_RIGHT} from 'components/Tooltip';
import {Request, RequestsMixin, GET, PUT} from 'requests';
import {ResourcesMatching, Requesting, Done, HasErrors} from 'requests/components';

const mapStateToProps = (state, props) => {
  return {
    kitToken: props.kitToken,
    requests: state.requests,
  };
};

const IconSettings = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      showModal: false,
      settings: null,
      isFocused: false,
      isSaving: false,
    };
  },

  componentWillMount() {
    const {settings} = this.state;

    this.setRequest({
      iconSettings: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'icon-settings'],
      }),
    });

    const rm = this.resourceManager();
    const iconSettings = rm.type(this.requests.iconSettings, 'icon-settings').get();

    if (!settings && rm.requests.isDone(this.requests.iconSettings)) {
      this.setState({settings: iconSettings});
    }
  },

  componentWillReceiveProps(nextProps) {
    const rm = this.resourceManager(nextProps);
    const {settings} = this.state;
    const iconSettings = rm.type(this.requests.iconSettings, 'icon-settings').get();

    if (!settings && rm.requests.isDone(this.requests.iconSettings)) {
      this.setState({settings: iconSettings});
    }

    if (rm.requests.isDone(this.requests.updateIconSettings)) {
      this.setState({
        settings: iconSettings,
        isSaving: false,
        showModal: false,
      });
    }

    if (rm.requests.hasErrors(this.requests.updateIconSettings)) {
      this.setState({
        isSaving: false,
      });
    }
  },

  handleOpened(event) {
    event.preventDefault();

    this.setState({showModal: true, isFocused: false});
  },

  handleClosed() {
    this.setState({showModal: false});
  },

  handleFocused() {
    this.setState({isFocused: !this.state.isFocused});
  },

  handleSaved() {
    const {settings} = this.state;

    this.setState({isSaving: true});

    this.setRequest({
      updateIconSettings: new Request({
        url: ['api', 'kits', this.props.kitToken, 'icon-settings'],
        method: PUT,
        record: settings,
      }),
    });
  },

  handlePrefixChanged(event) {
    const {settings} = this.state;

    this.setState({
      settings: settings.set(event.target.name, event.target.value),
    });
  },

  handleChecked(event) {
    const {settings} = this.state;

    this.setState({
      settings: settings.set(event.target.name, event.target.checked),
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      iconSettings: rm.type(this.requests.iconSettings, 'icon-settings').all(),
    };
  },

  renderModal() {
    const {showModal, isSaving, settings} = this.state;

    const rm = this.resourceManager();
    const cssPrefixClassNames = classnames(
      'form-group',
      'row',
      'required',
      {'has-danger': rm.requests.hasErrors(this.requests.updateIconSettings)},
    );

    const submitLabel = (isSaving) ? 'Saving...' : <span>Save Icon Settings <i className="ficon ficon-check-circle p-xs-l-xs"></i></span>;

    return (
      <Modal contentLabel="Icon settings" isOpen={showModal} onRequestClose={this.handleClosed}>
        <ResourcesMatching manager={rm}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-body dashed dashed-bottom m-xs-b-xs p-xs-b-sm">
                <button onClick={this.handleClosed} type="button" className="close close-dangle" aria-label="Close">
                  <span aria-hidden="true"><i className="ficon ficon-times"></i></span>
                </button>
                <h3 className="modal-title" id="icon-settings-modal"><i className="ficon ficon-gear text-gray-lighter m-xs-r-xs"></i> Icon Settings</h3>
              </div>
              <div className="modal-body">
                <form className="simple_form form-horizontal">
                  <div className={cssPrefixClassNames}>
                    <label className="required col-xs-4 form-control-label p-xs-r-sm">
                      CSS Prefix <span title="Required">*</span>
                    </label>
                    <div className="col-xs-8">
                      <input className="required form-control" type="text" value={settings.cssPrefix} name="cssPrefix" onChange={this.handlePrefixChanged} />
                      <HasErrors request={this.requests.updateIconSettings} errorKey="cssPrefix">
                        <span className="text-help text-muted p-xs-t-xs">{rm.requests.errorsFor(this.requests.updateIconSettings).get('cssPrefix')}</span>
                      </HasErrors>
                      <p className="text-sm text-muted p-xs-t-xs">Namespaces all classes in your kit.<br />e.g. &lt;i class='{settings.cssPrefix} {settings.cssPrefix}-check {settings.cssPrefix}-lg'&gt;&lt;/i&gt;</p>
                    </div>
                  </div>
                  <div className="form-group row text required" data-role="field-container">
                    <label className="text required col-xs-4 form-control-label">
                      CSS Features <span title="Required">*</span>
                    </label>
                    <div className="col-xs-8">
                      <div className="checkbox">
                        <span className="text-muted pull-xs-right">.15 KB</span>
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.largerIconSizes} name="largerIconSizes" onChange={this.handleChecked} /> Larger Icon Sizes
                        </label>
                      </div>
                      <div className="checkbox">
                        <span className="text-muted pull-xs-right">.05 KB</span>
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.fixedWidthIcons} name="fixedWidthIcons" onChange={this.handleChecked} /> Fixed Width Icons
                        </label>
                      </div>
                      <div className="checkbox">
                        <span className="text-muted pull-xs-right">.23 KB</span>
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.listIcons} name="listIcons" onChange={this.handleChecked} /> List Icons
                        </label>
                      </div>
                      <div className="checkbox">
                        <span className="text-muted pull-xs-right">.19 KB</span>
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.borderedPulledIcons} name="borderedPulledIcons" onChange={this.handleChecked} /> Bordered &amp; Pulled Icons
                        </label>
                      </div>
                      <div className="checkbox">
                        <span className="text-muted pull-xs-right">.49 KB</span>
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.spinningIcons} name="spinningIcons" onChange={this.handleChecked} /> Animated Icons
                        </label>
                      </div>
                      <div className="checkbox">
                        <span className="text-muted pull-xs-right">.97 KB</span>
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.rotatedFlippedIcons} name="rotatedFlippedIcons" onChange={this.handleChecked} /> Rotated &amp; Flipped Icons
                        </label>
                      </div>
                      <div className="checkbox m-xs-b-sm">
                        <span className="text-muted pull-xs-right">.27 KB</span>
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.stackedIcons} name="stackedIcons" onChange={this.handleChecked} /> Stacked Icons
                        </label>
                      </div>
                      <p className="text-sm text-muted m-xs-b-0">Reduce kit size by selecting fewer CSS features.</p>
                    </div>
                  </div>
                  <div className="form-group row text required">
                    <label className="required col-xs-4 form-control-label p-xs-y-0 p-xs-r-sm">
                      Accessibility <span title="Required">*</span>
                    </label>
                    <div className="col-xs-8">
                      <div className="checkbox">
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.autoA11y} name="autoA11y" onChange={this.handleChecked} /> Automatically make icons more accessible
                          <p className="text-sm text-muted m-xs-b-0">Have accessibility best practices applied automatically to your icons.</p>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row text required">
                    <label className="required col-xs-4 form-control-label p-xs-y-0 p-xs-r-sm">
                      Performance <span title="Required">*</span>
                    </label>
                    <div className="col-xs-8">
                      <div className="checkbox">
                        <label>
                          <input className="boolean" type="checkbox" checked={settings.asyncLoading} name="asyncLoading" onChange={this.handleChecked} /> Load CSS asynchronously
                          <p className="text-sm text-muted m-xs-b-0">Don't let icons slow down your pages from loading. Load them in quickly in the background.</p>
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer bg-body">
                <button onClick={this.handleClosed} type="button" className="btn btn-link">Cancel</button>
                <button onClick={this.handleSaved} type="submit" disabled={isSaving} className="btn btn-primary">
                   {submitLabel}
                </button>
              </div>
            </div>
          </div>
        </ResourcesMatching>
      </Modal>
    );
  },

  renderMain() {
    const {isFocused} = this.state;
    const popover = (isFocused) ? <Tooltip noIcon={true} content="Icon Settings" position={TOOLTIP_POSITION_RIGHT} /> : null;

    return (
      <span>
        <a href="#" className="text-muted text-lg has-tooltip link-dashed-none" onClick={this.handleOpened} onMouseOver={this.handleFocused} onMouseOut={this.handleFocused}>
          {popover}
          <i className="ficon ficon-gear" ></i>
        </a>
        {this.renderModal()}
      </span>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()} request={this.requests.iconSettings} element="span">
        <Done render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(IconSettings);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/IconSettings.js